export default {
  RESTAURANT_ID: process.env.REACT_APP_RESTAURANT_ID,
  LOCATION_ID: process.env.REACT_APP_LOCATION_ID,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY
};
